'use strict';
import isFunction from 'lodash/isFunction';
import isUndefined from 'lodash/isUndefined';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/switchMap';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {ButtonView} from './ButtonView';


export class ButtonComponent extends Component {
  static propTypes = {
    className: T.string,
    activeClassName: T.string,
    disabledClassName: T.string,
    disabled: T.bool,
    useClickBlock: T.bool,
    title: T.string,
    label: T.node,
    labelClass: T.string,
    // Deprecated. Replaced by leftIconClass
    iconClass: T.string,
    leftIconClass: T.string,
    rightIconClass: T.string,
    setButtonRef: T.func,
    onClick: T.func,
    bindParam: T.any,
    useArrayArgs: T.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }

  componentDidMount() {
    if (this.props.useClickBlock) {
      this.useClickBlock = true;
      this.blocked$ = new Subject();
      this.blockedSubscription = this.blocked$
        .switchMap(() => Observable.timer(300))
        .subscribe(() => this.blocked = false);
    }
  }

  componentWillUnmount() {
    this.blockedSubscription && this.blockedSubscription.unsubscribe();
    this.stateSubscription = null;
  }

  handleClick(e) {
    e.stopPropagation();
    if (this.blocked) {
      return;
    } else if (this.useClickBlock) {
      this.blocked$.next();
      this.blocked = true;
    }

    if (!this.props.disabled && isFunction(this.props.onClick)) {
      if (!isUndefined(this.props.bindParam)) {
        if (this.props.useArrayArgs) {
          this.props.onClick([e, this.props.bindParam]);
        } else {
          this.props.onClick(e, this.props.bindParam);
        }
      } else {
        this.props.onClick(e);
      }
    }
  }

  handleMouseDown(e) {
    e.stopPropagation();
    if (!this.props.disabled) {
      this.setState({active: true});
    }
  }

  handleMouseUp(e) {
    e.stopPropagation();
    if (!this.props.disabled) {
      this.setState({active: false});
    }
  }

  render() {
    return (
      <ButtonView
        className={this.props.className}
        activeClassName={this.props.activeClassName}
        disabledClassName={this.props.disabledClassName}
        disabled={this.props.disabled}
        active={this.state.active}
        title={this.props.title}
        label={this.props.label}
        labelClass={this.props.labelClass}
        leftIconClass={this.props.iconClass || this.props.leftIconClass}
        rightIconClass={this.props.rightIconClass}
        setButtonRef={this.props.setButtonRef}
        onClick={this.handleClick}
        onTouchStart={this.handleMouseDown}
        onTouchEnd={this.handleMouseUp}
        onMouseDown={this.handleMouseDown}
        onMouseUp={this.handleMouseUp}
      >
        {this.props.children}
      </ButtonView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/buttons/Button/ButtonComponent.js